import { render } from "./ContenuMain.vue?vue&type=template&id=d0a80f40"
import script from "./ContenuMain.vue?vue&type=script&lang=js"
export * from "./ContenuMain.vue?vue&type=script&lang=js"

import "./ContenuMain.vue?vue&type=style&index=0&id=d0a80f40&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__